module.exports = __webpack_public_path__ + "static/media/buildings.997595b7.svg";